import { AppContext, Util } from "Core";
import { EncodingTypes } from "Enums";
import { IDisposable } from "Core/Interfaces";

/**
 * Extension for tooltip support.
 * @hidden
 */
export class TooltipExtension implements IDisposable {
    /**
     * @hidden
     */
    protected tooltip: kendo.ui.Tooltip;

    /**
     * @hidden
     */
    protected helpTextTooltip: kendo.ui.Tooltip;

    private helpTextSecondClickEventHandler: any;

    /**
     * @hidden
     */
    public static helpTextTooltipTemplate: string = require("../Templates/HelpTextTooltip.html").default;

    /**
     * @hidden
     */
    protected userPickerTooltip: kendo.ui.Tooltip;

    /**
     * @hidden
     */
    public static userPickerTooltipTemplate: string = require("../Templates/UserPickerPopup.html").default;

    /**
     * Initialize tooltips.
     * @param container Container which contains the tooltips.
     * @hidden
     */
    public initialize(container: JQuery): void {
        if (this.tooltip) {
            return;
        }

        let options: kendo.ui.TooltipOptions = {
            filter: ".dms-tooltip[data-dms-tooltip]:not(.dms-tooltip[data-dms-tooltip=''])", // get all tooltip elements where the tooltip is not empty
            showAfter: 500,
            content: function (e: any) {
                let target = <JQuery>e.target;
                let text = target.attr("data-dms-tooltip");
                text = Util.decode(text, EncodingTypes.HtmlAttribute).split("\n").join("<br/>");
                return text;
            },
            show: function (e: any) {
                this.refresh();
                let target = <JQuery>this.target();
                if (target && target.is(":visible") && target.is(":hover")) {
                    this.content.parent().css("visibility", "visible");
                }
            },
            hide: function (e: any) {
                this.content.parent().css("visibility", "hidden");
            },
        };

        this.tooltip = new kendo.ui.Tooltip(container[0], options);

        if (this.helpTextTooltip) {
            this.helpTextTooltip.destroy();
        }

        let tooltipExtension = this;
        this.helpTextSecondClickEventHandler = this.onHelpTextSecondClick.bind(this);

        let helpOptions: kendo.ui.TooltipOptions = {
            filter: ".dms-helptext[data-dms-helptext]:not(.dms-helptext[data-dms-helptext=''])", // get all tooltip elements where the tooltip is not empty
            showOn: "click",
            autoHide: false,
            width: 300,
            content: function (e: any) {
                let target = <JQuery>e.target;
                let text = target.data("dms-helptext");
                text = Util.decode(text, EncodingTypes.HtmlAttribute).split("\n").join("<br/>");
                return kendo.template(TooltipExtension.helpTextTooltipTemplate, { useWithBlock: false })(text);
            },
            show: function (e: any) {
                let target = <JQuery>this.target();
                if (target && target.is(":visible")) {
                    this.content.parent().css("visibility", "visible");
                }
                target.on("click", tooltipExtension.helpTextSecondClickEventHandler);
            },
            hide: function (e: any) {
                let target = <JQuery>this.target();
                target.off("click", tooltipExtension.helpTextSecondClickEventHandler);
                this.content.parent().css("visibility", "hidden");
            },
        };

        this.helpTextTooltip = new kendo.ui.Tooltip(container[0], helpOptions);

        let userPickerOptions: kendo.ui.TooltipOptions = {
            filter: ".dms-userpicker-label[data-dms-userid]", // get all tooltip elements where the tooltip is not empty
            showAfter: 500,
            autoHide: true,
            width: 300,
            callout: false,
            content: function (e: any) {
                let target = <JQuery>e.target;
                let id = target.data("dms-userid");
                AppContext.current.serviceProvider.User.getUser(id).then((val) => {
                    e.sender.content.html(kendo.template(TooltipExtension.userPickerTooltipTemplate, { useWithBlock: false })(val));
                });
                return "";
            },
            show: function (e: any) {
                this.popup.element.addClass("dms-userpicker-popup");
                let target = <JQuery>this.target();
                if (target && target.is(":visible") && target.is(":hover")) {
                    this.content.parent().css("visibility", "visible");
                }
            },
            hide: function (e: any) {
                this.content.parent().css("visibility", "hidden");
            },
        };

        this.userPickerTooltip = new kendo.ui.Tooltip(container[0], userPickerOptions);
    }

    /**
     * Show the help text for a specific element.
     * @param element Element which has a help text.
     * @hidden
     */
    public showHelpTextForElement(element: JQuery): void {
        if (this.helpTextTooltip) {
            this.helpTextTooltip.show(element);
        }
    }

    /**
     * Handler occurs when the control value changes to load dependent control data.
     * @param e EventArgs.
     */
    private onHelpTextSecondClick(e: JQuery.ClickEvent<HTMLElement>) {
        this.helpTextTooltip.hide();
    }

    /**
     * Hide the tooltips.
     * @hidden
     */
    public hide(): void {
        if (this.tooltip) {
            this.tooltip.hide();
        }
    }

    /**
     * Dispose the extension.
     */
    public dispose(): void {
        if (this.tooltip) {
            this.tooltip.destroy();
            this.tooltip = undefined;
        }
        if (this.helpTextTooltip) {
            this.helpTextTooltip.destroy();
            this.helpTextTooltip = undefined;
        }
    }
}
